import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { ofArray, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Page } from "./Types.fs.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (model) => {
    if (model.tag === 1) {
        return new PageHeader(1, [toText(printf("Administration: %s"))(model.fields[0].Key)]);
    }
    else {
        return new PageHeader(1, ["Administration: Texte"]);
    }
}, (_arg_2) => (!isEmpty(_arg_2) ? ((head(_arg_2) === "admin") ? (!isEmpty(tail(_arg_2)) ? ((head(tail(_arg_2)) === "text") ? (isEmpty(tail(tail(_arg_2))) ? (new Page(0, [])) : (isEmpty(tail(tail(tail(_arg_2)))) ? (new Page(1, [head(tail(tail(_arg_2)))])) : undefined)) : undefined) : undefined) : undefined) : undefined), (_arg_1) => {
    if (_arg_1.tag === 1) {
        return ofArray(["admin", "text", _arg_1.fields[0]]);
    }
    else {
        return ofArray(["admin", "text"]);
    }
}, (_arg) => {
    if (_arg.tag === 11) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
